import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Creates a Retained Net Income with its selected cutoffs
export const createRetainedNetIncome = async (payload) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/retained_net_income/createRetainedNetIncome`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
